import React, { useEffect, useState } from 'react';
import Head from '../../../../layout/head/Head';
import Content from '../../../../layout/content/Content';
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, Col, Icon, Row } from '../../../../components/Component';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import AuthTenantNoData from '../../../error/AuthTenantNoData';
import { useDispatch } from 'react-redux';
import { RETRIEVE_TENANT_PROMOTIONS_USSD_CODE_SETTINGS_API } from '../../../../api/api_data';
import * as app_consts from "../../../../utils/app_consts";
import { RETRIVE_SPECIFIC_TENANT_SETTINGS_ERROR_MSG, RETRIVE_SPECIFIC_TENANT_SETTINGS_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { fail_retrieve_ussd_settings, loading_retrieve_ussd_settings, reset_retrieve_ussd_settings, success_retrieve_ussd_settings } from '../../../../reducers/auth_tenant/retrieve_ussd_settings_Slice';
import { messageToast } from '../../../../utils/Utils';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { Link } from 'react-router-dom';
import CreateUssdModal from '../../../../components/modal/promotions/CreateUssdModal';
import EditUSSDCodeSettingMondal from '../../../../components/modal/promotions/EditUSSDCodeSettingMondal';

const PromotionsUSSDSettings = ({ tenant_info, user_info }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState([]);
  const [current_page_data, setCurrentPageData] = useState([]);
  const dispatch = useDispatch();
  const [sm, updateSm] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [create_ussd_code_modal, setCreateUSSDCodeModal] = useState(false);
  const [edit_codes_modal, setEditCodeModal] = useState(false);
  const [selected_code, setSelectedCode] = useState("");

  const open_edit_codes_modal = (item) => {
    setEditCodeModal(true);
    setSelectedCode(item);
  };

  const close_edit_codes_modal = () => {
    setEditCodeModal(false);
    setSelectedCode('');
  };

  const edit_codes_modal_successFunction = () => {
    close_edit_codes_modal();
    retrieve_data();
  };

  const open_create_ussd_code_modal = () => {
    setCreateUSSDCodeModal(true);
  };

  const close_create_ussd_code_modal = () => {
    setCreateUSSDCodeModal(false);
  };

  const create_ussd_code_modal_successFunction = () => {
    close_create_ussd_code_modal();
    retrieve_data();
  };

  useEffect(() => {
    retrieve_data();
  }, []);


  const retrieve_data = () => {
    setError("");
    setLoading(true);
    // Retreive Employees
    dispatch(tenant_auth_actions_helper(loading_retrieve_ussd_settings, success_retrieve_ussd_settings, fail_retrieve_ussd_settings, RETRIVE_SPECIFIC_TENANT_SETTINGS_ERROR_MSG, RETRIVE_SPECIFIC_TENANT_SETTINGS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_PROMOTIONS_USSD_CODE_SETTINGS_API}`));
  };
  // Listener
  const retrieve_ussd_settings_listener = useSelector((state) => state.retrieve_ussd_settings.retrieve_ussd_settings);

  useEffect(() => {
    if (retrieve_ussd_settings_listener.status !== app_consts.IDLE)
    {
      if (retrieve_ussd_settings_listener.status === app_consts.LOADING && !create_ussd_code_modal)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (retrieve_ussd_settings_listener.status === app_consts.FAIL && !create_ussd_code_modal)
        {
          messageToast(retrieve_ussd_settings_listener.message, app_consts.FAIL);
          setError(retrieve_ussd_settings_listener.message);
        } else if (retrieve_ussd_settings_listener.status === app_consts.SUCCESS)
        {
          messageToast(retrieve_ussd_settings_listener.message, app_consts.SUCCESS);
          setPageData(retrieve_ussd_settings_listener.data);
          setCurrentPageData(retrieve_ussd_settings_listener.data);
        }
        dispatch(reset_retrieve_ussd_settings());
      }
    }
  }, [retrieve_ussd_settings_listener]);

  return (
    <>
      <Head
        title={
          tenant_info?.name ? `${tenant_info.name} USSD Codes` : ' USSD Codes'
        }
      />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>USSD Codes</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(loading || error) && `USSD Codes ${page_data?.settings?.codes?.length || 0}`}</p>
              </BlockDes>
              {!(loading) && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      retrieve_data();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>
            {
              !(loading || error) && (
                <>
                  <BlockHeadContent>
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#more"
                        className="btn btn-icon btn-trigger toggle-expand me-n1"
                        onClick={(ev) => {
                          ev.preventDefault();
                          updateSm(!sm);
                        }}
                      >
                        <Icon name="more-v"></Icon>
                      </a>
                      <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                        <ul className="nk-block-tools g-3">
                          <li>
                            <div className="form-control-wrap">
                              <div className="form-icon form-icon-right">
                                <Icon name="search"></Icon>
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                id="default-04"
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                                placeholder="Search for USSD Codes"
                              />
                            </div>
                          </li>
                          {
                            (user_info?.roles?.includes(app_consts.ADMINISTRATOR) || user_info?.roles?.includes(app_consts.CREATE_PROMOTION)) && (
                              <>
                                <li className="nk-block-tools-opt">
                                  <Button
                                    className="toggle btn-icon d-md-none"
                                    color="primary"
                                    onClick={() => {
                                      open_create_ussd_code_modal();
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                  </Button>
                                  <Button
                                    className="toggle d-none d-md-inline-flex"
                                    color="primary"
                                    onClick={() => {
                                      open_create_ussd_code_modal();
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                    <span>Create USSD Code</span>
                                  </Button>
                                </li>
                              </>
                            )
                          }
                        </ul>
                      </div>
                    </div>
                  </BlockHeadContent>
                </>
              )
            }
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading USSD Codes..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      page_data?.settings?.codes && page_data?.settings?.codes?.length > 0 ?
                        <>
                          <Row className="g-gs">
                            {page_data?.settings?.codes?.map((code, index) => (
                              <Col xxl="6" key={index}>
                                <div className="nk-download">
                                  <div className="data">
                                    <div className="thumb">
                                      <Icon name="mobile" style={{ fontSize: "32px" }} />
                                    </div>

                                    <div className="info">
                                      <h6 className="title">
                                        <span className="name">{code?.name}</span>
                                      </h6>

                                      <div className="meta">
                                        <span className="version">
                                          <span className="text-soft">USSD Code: </span>
                                          <span>{code?.code}</span>
                                        </span>

                                        <span className="release">
                                          <span className="text-soft">Gateway URL: </span>
                                          <span className="text-break">
                                            {code?.gateway_url}
                                          </span>
                                        </span>

                                        <span className="status">
                                          <span className="text-soft">Status: </span>
                                          <span
                                            className={`text-${code?.status === "active" ? "success" : "danger"
                                              }`}
                                          >
                                            {code?.status?.replace(/_/g, ' ').toUpperCase()}
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  {/* No actions / no view button */}

                                  <div className="d-flex justify-content-end mt-4">
                                    <Button
                                      className="toggle d-md-inline-flex"
                                      color="primary"
                                      onClick={() => {
                                        open_edit_codes_modal(code);
                                      }}
                                    >
                                      <Icon name="edit"></Icon>
                                      <span>Edit USSD Code</span>
                                    </Button>
                                  </div>
                                </div>
                              </Col>
                            ))}
                            <EditUSSDCodeSettingMondal closeModal={close_edit_codes_modal} tenant_info={tenant_info} user_info={user_info} data={selected_code} successFunction={edit_codes_modal_successFunction} isOpen={edit_codes_modal} />
                          </Row>
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No USSD Codes Found"} />
                        </>
                    }
                    <CreateUssdModal tenant_info={tenant_info} user_info={user_info} successFunction={create_ussd_code_modal_successFunction} isOpen={create_ussd_code_modal} closeModal={close_create_ussd_code_modal} />
                  </>
              }
            </>
        }
      </Content>
    </>
  );
};

export default PromotionsUSSDSettings;